import React from 'react';
import { Grid } from '@mui/material';
import { Button } from 'vetrf-ui';
import { useFormContext } from 'react-hook-form';
import { FieldValues } from 'react-hook-form/dist/types';
import { defaultFilters } from 'components/FiltersContext/context';
import { FiltersType } from 'components/FiltersContext/types';

type FiltersButtonsProps = {
  onReset: (item: FieldValues) => void;
  selectResetList?: string[];
  filterName?: keyof FiltersType;
};

export const FiltersButtons = ({ onReset, selectResetList, filterName }: FiltersButtonsProps) => {
  const { reset, getValues, setValue } = useFormContext();

  const handleReset = () => {
    reset();
    if (filterName) {
      if (defaultFilters[filterName]) {
        Object.entries(defaultFilters[filterName]!).forEach(([key, value]) => {
          setValue(key, value);
        });
      }
    }
    const defaultValues = getValues();
    onReset(defaultValues);
    if (selectResetList && selectResetList.length > 0) {
      for (let index = 0; index < selectResetList.length; index += 1) {
        setValue(selectResetList[index], null);
      }
    }
  };
  return (
    <Grid container spacing={2} mt={1} justifyContent="flex-end">
      <Grid item>
        <Button
          type="submit"
          color="primary"
          size="sm"
          text="Найти"
          icon="search"
          iconColor="white"
          iconSize={100}
        />
      </Grid>
      <Grid item>
        <Button
          color="grey"
          onClick={handleReset}
          size="sm"
          text="Сбросить"
          icon="times"
          iconColor="white"
          iconSize={100}
        />
      </Grid>
    </Grid>
  );
};
